export default "__VITE_ASSET__Bjh7$uSN__"